import * as React from "react";
import { cn } from "../../lib/utils";

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {}

const Kbd = React.forwardRef<HTMLElement, KbdProps>(
	({ className, ...props }, ref) => {
		return (
			<kbd
				ref={ref}
				className={cn(
					"mono inline-flex items-center justify-center min-w-[18px] " +
						"text-[10px] px-1 py-0.5 rounded " +
						"bg-gray-100 dark:bg-white/[0.06] " +
						"border border-gray-200 dark:border-white/[0.08] " +
						"text-gray-700 dark:text-gray-300",
					className,
				)}
				{...props}
			/>
		);
	},
);
Kbd.displayName = "Kbd";

export { Kbd };
